import React from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';

import { setCaseIntendedClientId } from '../store/slices/intendedInfoSlice';

class ShowClientPage extends React.Component {
  state = {
    redirect: undefined,
    clientId: 0,
  };

  componentDidMount() {
    this.extractIdAndSetStateFromUrl();
  }

  extractIdAndSetStateFromUrl() {
    const url = window.location.href;
    const eqLoc = url.lastIndexOf('=');
    const idStr = url.substring(eqLoc + 1);
    const id = parseInt(idStr);
    this.props.setCaseIntendedClientId(id);
    this.setState({ clientId: id });
  }

  render() {
    if (this.state.clientId) {
      return <Redirect to="case" />;
    } else {
      return null;
    }
  }
}

const actionProducers = {
  setCaseIntendedClientId,
};

export default connect(null, actionProducers)(ShowClientPage);
